import isNil from 'lodash/isNil';
import upperFirst from 'lodash/upperFirst';

export const toTitleCase = (str)=> {
  if (isNil(str)) {
    return '';
  }

  return str.replace(/\w\S*/g, (s)=> `${s.charAt(0).toUpperCase()}${s.substr(1).toLowerCase()}`);
};

export const leftPad = (str, padStr, len)=> {
  var newStr = str.toString();

  while (newStr.length < len) {
    newStr = padStr + newStr;
  }

  return newStr;
};


export const rightPad = (str, padStr, len)=> {
  var newStr = str;

  while (newStr.length < len) {
    newStr = newStr + newStr;
  }

  return newStr;
};

export function sentenceFromCamelcase(camelcaseString) {
  const splitString = camelcaseString.split(/(?=[A-Z])/);
  const firstWord = upperFirst(splitString.shift());

  return [firstWord, ...splitString].join(' ');
}
